<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly && member.role !== 'Agent' && member.role !== 'Salesperson'" transition="fade-transition" max-width="600px")
    v-card
      v-card-title.px-5
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="openLeavingDialog = true" height)
              v-icon(color="basic800" :size="24") mdi-close
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('new_sales_page') }}

      v-progress-linear.mt-2(v-if="step !== 7" color="primary500" background-color="basic300" height="4" :value="currentProgress")
      v-card-text.pa-0
        v-window(v-model="step" touchless)
          v-window-item(:value="0")
            v-container.pt-5.px-5.pb-0
              div.h5.primary--text {{ $t('lets_get_started') }}
              div.p1.basic700--text.mt-4 {{ $t('heres_how_page') }}
              div.mt-4
                iframe(src="https://yzza.io/jy7ll" title="Example Sales Page" :width="iframeWidth" :height="iframeHeight" frameborder="0")

          //- WRITING LANDING PAGE
          v-window-item(:value="1")
            landing-page-editor(:parentForm.sync="form")
              template(#title)
                div.h5.primary--text {{ $t('lets_start_writing') }}
                div.s1.primary--text.mt-4 {{ $t('tell_visitor') }}
                div.p2.basic700--text.mt-1 {{ $t('dont_worry_edit_later') }}
          
          //- ATTACH PRODUCT
          v-window-item(:value="2")
            product-management(:parentForm.sync="form")
          
          //- FORM TYPE
          v-window-item(:value="3")
            landing-form-type(:parentForm.sync="form")

          //- EXTRA FIELD
          v-window-item(:value="4")
            landing-extra-field(:parentForm.sync="form")

          //- SALESPERSON
          v-window-item(:value="5")
            landing-sales-person(:parentForm.sync="form" :company="company")

          //- LANDING PAGE NAME
          v-window-item(:value="6")
            v-container.pa-5
              div.h5.primary--text {{ $t('lets_give_title') }}
              div.p1.basic700--text.mt-4 {{ $t('this_only_reference') }}
              v-form(ref="form")
                v-text-field.mt-4(v-model='form.name' background-color="basic200" height="40" outlined dense persistent-hint counter :maxlength="100" placeholder="My Sales Page" :rules="rules.not_empty")

          v-window-item(:value="7")
            v-container.pa-5
              v-img.mx-auto(:src="require('@/assets/images/bg_order_confirmation2.gif')" style="height:177px" contain)
              div.text-center
                div.h5.basic700--text {{ $t('awesome') }}!
                div.p1.basic700--text.mt-4 {{ $t('your_sales_page_ready') }}
                v-btn.button-AA-medium.basic100--text.mt-8(color="primary" depressed block @click="clickViewPage") {{ $t('view_your_page') }}
                v-btn.button-AA-medium.mt-4(v-if="this.Auth('component', '/admin/landing-pages#landing_page_action')" color="primary" depressed block outlined @click="clickCopyLink") {{ $t('copy_page_link') }}
                v-btn.button-Aa-medium.mt-4(color="primary" text depressed block @click="$emit('refresh'); showModal = false") {{ $t('finish_setup') }}
                div(ref="copy")
                

      v-card-actions.pb-4.px-4(v-if="step !== 7")
        v-spacer
        v-btn.button-Aa-medium(v-if="step !== 0" color='primary400' text height=32 @click="step--") {{ $t('back') }}
        v-btn.mr-2.button-AA-medium(color='info500' depressed height=32 @click="nextStep('next')" :loading="isLoading" :dark="!nextDisabled" :disabled="nextDisabled")
          div(:class="{ 'basic100--text' : !nextDisabled }") {{ $t('next') }}

      .modals
        y-dialog(v-if="openLeavingDialog" v-model='openLeavingDialog', max-width='320')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('leaving') }}
            v-card-text.p2.primary500--text.px-4 {{ $t('well_save_your_progress') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click="nextStep('exit')")
                .button-Aa-small.primary400--text {{ $t('save_and_exit') }}
              v-btn.mr-2(color='info500' depressed height=32 @click='openLeavingDialog = false' dark :loading="isLoading")
                .button-AA-small.basic100--text {{ $t('keep_working') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LandingPageEditor from '@/components/landingform/LandingPageEditor.vue'
import ProductManagement from '@/components/landingform/ProductManagement.vue'
import LandingFormType from '@/components/landingform/LandingFormType.vue'
import LandingExtraField from '@/components/landingform/LandingExtraField.vue'
import LandingSalesPerson from '@/components/landingform/LandingSalesPerson.vue'

export default {
  name: 'AddLandingForm',
  props: ['open', 'company'],
  components: { LandingPageEditor, ProductManagement, LandingFormType, LandingExtraField, LandingSalesPerson },
  data: () => ({
    isLoading: false,
    step: 0,
    landingFormError: false,
    openLeavingDialog: false,
    form: {},
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    }
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    currentProgress () {
      return Math.ceil((this.step / 6) * 100)
    },
    nextDisabled () {
      if ((this.step === 2 && this.form.products.length === 0 ) || (this.step === 5 && this.form.members.length === 0)) {
        return true
      }
      return false
    },
    iframeWidth () {
      if (screen.width < 600) {
        return screen.width - 40
      }
      return 560
    },
    iframeHeight () {
      if (screen.width < 600) {
        return window.innerHeight - 250
      }
      return window.innerHeight - 480
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    nextStep (val) {
      switch (this.step) {
        case 0 :
          this.saveInitial(val)
          break
        case 1 : {
          let data = {
            landing_field: this.form.landing_field
          }
          this.saveForm(data, val)
          break
        }
        case 2 : {
          let data = {
            products: this.form.products.map(m => m.id),
            hide_soldout_products: this.form.hide_soldout_products,
            show_stock_level: this.form.show_stock_level,
            show_stock_level_when_low: this.form.show_stock_level_when_low
          }
          this.saveForm(data, val)
          break
        }
        case 3 : {
          let data = {
            type: this.form.type
          }
          this.saveForm(data, val)
          break
        }
        case 4 : {
          let data = {
            language: this.form.language,
            email_enabled: this.form.email_enabled,
            email_required: this.form.email_required,
            extra_fields: this.form.extra_fields || []
          }
          this.saveForm(data, val)
          break
        }
        case 5 : {
          let data = {
            members: this.form.members.map(m => m.id),
          }
          this.saveForm(data, val)
          break
        }
        case 6 : {
          if (!this.$refs.form.validate()) {
            break
          } else {
            let data = {
              name: this.form.name,
            }
            if (this.Auth('component', '/admin/landing-pages#landing_page_action')) {
              data['status'] = 'published'
            }
            this.saveForm(data, val)
            break
          }
        }
        default : {
          if (val === 'next') {
            this.step++
          } else {
            this.$emit('refresh')
            this.showModal = false
          }
        }
      }
    },
    saveInitial (val) {
      if (Object.keys(this.form).length > 1) {
        if (val === 'next') {
          this.step++
        } else {
          this.$emit('refresh')
          this.showModal = false
        }
        return
      }
      this.isLoading = true
      let data = {
        name: 'My Sales Page',
        layout: 'landing',
        company: this.company.id,
        language: 'en'
      }
      this.$axios.post('/forms', data)
        .then(resp => {
          this.form = { ...resp.data }
          if (val === 'next') {
            this.step++
          } else {
            this.$emit('refresh')
            this.showModal = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveForm (data, val) {
      if (!this.form) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }
      this.isLoading = true
      this.$axios.patch(`/forms/${this.form.id}`, data)
        .then(resp => {
          this.form = { ...resp.data }
          if (val === 'next') {
            this.step++
          } else {
            this.$emit('refresh')
            this.showModal = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickViewPage () {
      let domain = `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/`
      let url = domain +  this.form.slug + '?preview=true'
      window.open(url)
    },
    clickCopyLink () {
      let domain = `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/`
      let url = domain +  this.form.slug
      let container = this.$refs.copy
      this.$copyText(url, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "new_sales_page": "New Sales Page",
    "lets_get_started": "Let’s get started",
    "heres_how_page": "Here’s how your sales page will look like.",
    "lets_start_writing": "Let’s start writing",
    "tell_visitor": "Tell visitors what’s great about your product",
    "dont_worry_edit_later": "Don’t worry - you can always add to or edit this content later.",
    "lets_give_title": "Let’s give this sales page a title",
    "this_only_reference": "This is only for your reference. Your customers won’t see this.",
    "awesome": "Awesome",
    "your_sales_page_ready": "Your new sales page is now ready to be published and shared.",
    "view_your_page": "View your page",
    "copy_page_link": "Copy page link",
    "finish_setup": "Finish setup",
    "leaving": "Leaving?",
    "well_save_your_progress": "We’ll save your progress so you can come back and finish later.",
    "save_and_exit": "Save & exit",
    "keep_working": "Keep working"
  },
  "id": {
    "new_sales_page": "Halaman Penjualan Baru",
    "lets_get_started": "Mulai buat Halaman Toko kamu",
    "heres_how_page": "Contoh Halaman Toko yang dapat menarik perhatian pelanggan!",
    "lets_start_writing": "Isi Halaman Toko kamu",
    "tell_visitor": "Buatlah pelanggan tertarik dengan produk kamu",
    "dont_worry_edit_later": "Kamu dapat mengubah halaman ini kapanpun setelah disimpan",
    "lets_give_title": "Beri Judul",
    "this_only_reference": "Pelanggan kamu tidak akan melihat ini",
    "awesome": "Awesome",
    "your_sales_page_ready": "Halaman penjualan kamu siap untuk dipublikasikan",
    "view_your_page": "Lihat halaman",
    "copy_page_link": "Salin tautan halaman",
    "finish_setup": "Selesai",
    "leaving": "kamu yakin ingin meninggalkan perubahan?",
    "well_save_your_progress": "Kami akan menyimpan kemajuan kamu",
    "save_and_exit": "Simpan dan Keluar",
    "keep_working": "Tetap bekerja"
  }
}
</i18n>